/**
 * JSON-RPC 2.0 reserved error codes, plus the EIP-1474 execution-reverted
 * code used by EVM nodes. These are the codes the Spectrum server emits —
 * see `spectrum-node/src/rpc/types.rs` for the constructors that produce
 * them. Keep the two in sync.
 */
export const JSON_RPC_ERROR_CODE = {
    PARSE_ERROR: -32700,
    INVALID_REQUEST: -32600,
    METHOD_NOT_FOUND: -32601,
    INVALID_PARAMS: -32602,
    INTERNAL_ERROR: -32603,
    SERVER_ERROR: -32000,
    EXECUTION_REVERTED: 3,
};
/** Canonical JSON-RPC 2.0 protocol version string used in every envelope. */
export const JSON_RPC_VERSION = '2.0';
/** Hard cap on batched JSON-RPC requests accepted by Spectrum endpoints. */
export const MAX_JSON_RPC_BATCH_SIZE = 50;
/**
 * Starknet transaction-submission methods the RPC proxy refuses to forward.
 */
export const BLOCKED_STARKNET_METHODS = [
    'starknet_addInvokeTransaction',
    'starknet_addDeclareTransaction',
    'starknet_addDeployAccountTransaction',
];
